<template>
  <div id="page-product-details">

    <div class="mb-4">
      <h1>Product: {{ model.ProductCode }}</h1>
    </div>

    <product-form
        v-model="model"
        :loading="loading"
        ref="form"
        card-title="Edit Product"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              @click="$router.push({ name: 'products.view', params: { id } })"
              class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              @click="save"
              class="my-4"
              color="light"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ProductForm from "@/views/pages/products/ProductForm";
import ViewModelMixin from "@/components/mixins/ViewModelMixin";
import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  name: "ProductEdit",
  components: {
    ProductForm
  },
  mixins: [ViewModelMixin,NotificationMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.products,
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      }

      const references = [
        'LIORiskCode_FK',
        'LloydsRiskCode_FK',
        'InsuranceType_FK',
        'ProductOwner_FK',
        'Wording_FK',
        'FrontJacket_FK',
        'RearJacket_FK',
        'StandardClause_FK',
      ]

      references.forEach((ref) => params[ref] = this.getReferenceId(ref))

      return params;
    },
    getReferenceId(fieldName) {
      if (!this.model[fieldName]) {
        return null;
      }

      return this.model[fieldName].id || null;
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();

      //  return;
      try {
        const {data} = await this.$api.products.update(this.id, params);
        this.notifySuccess('Product updated');
        this.$router.back();
      } catch (e) {
        this.notifyError('Product failed to be created');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
